"use strict";
var __values = (this && this.__values) || function (o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
};
Object.defineProperty(exports, "__esModule", { value: true });
var CSSUtil_1 = require("./CSSUtil");
var StyleProxy = /** @class */ (function () {
    function StyleProxy(root) {
        this.root = null;
        this.observers = new Set();
        this.root = root;
    }
    StyleProxy.prototype.setRoot = function (root) {
        if (this.root == root)
            return;
        this.root = root;
        this.updateObservers();
    };
    StyleProxy.prototype.getRoot = function () {
        return this.root;
    };
    StyleProxy.prototype.getStyle = function (selector) {
        var node = selector == null ? this.root : this.root.querySelector(selector);
        if (node instanceof Element) {
            return window.getComputedStyle(node);
        }
        else {
            return null;
        }
    };
    StyleProxy.prototype.getColor = function (propertyName, selector) {
        var css = this.getStyle(selector);
        if (css != null) {
            var valueString = css.getPropertyValue(propertyName);
            return valueString === '' ? null : CSSUtil_1.CSSUtil.parseColor(css.getPropertyValue(propertyName));
        }
        else {
            return null;
        }
    };
    StyleProxy.prototype.getNumber = function (propertyName, selector) {
        var css = this.getStyle(selector);
        if (css != null) {
            return parseFloat(css.getPropertyValue(propertyName));
        }
        else {
            return null;
        }
    };
    StyleProxy.prototype.observeAllStyle = function (callback) {
        return this.createMutationObserver(null, callback);
    };
    StyleProxy.prototype.observeDescendantStyle = function (selector, callback) {
        return this.createMutationObserver(selector, callback);
    };
    StyleProxy.prototype.removeObserver = function (observer) {
        var e_1, _a;
        try {
            for (var _b = __values(this.observers), _c = _b.next(); !_c.done; _c = _b.next()) {
                var item = _c.value;
                if (item.observer === observer) {
                    item.observer.disconnect();
                    this.observers.delete(item);
                    return true;
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return false;
    };
    StyleProxy.prototype.removeAllObservers = function () {
        var e_2, _a;
        try {
            for (var _b = __values(this.observers), _c = _b.next(); !_c.done; _c = _b.next()) {
                var item = _c.value;
                item.observer.disconnect();
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_2) throw e_2.error; }
        }
        this.observers = new Set();
    };
    StyleProxy.prototype.createMutationObserver = function (selector, callback) {
        var observer = new MutationObserver(function (mutations) {
            mutations.forEach(function (mutationRecord) {
                callback(mutationRecord.target, window.getComputedStyle(mutationRecord.target));
            });
        });
        var proxyObserver = {
            selector: selector,
            callback: callback,
            observer: observer,
        };
        this.observers.add(proxyObserver);
        if (this.root != null) {
            this.applyProxyObserver(proxyObserver);
        }
        return observer;
    };
    StyleProxy.prototype.updateObservers = function () {
        var e_3, _a;
        if (this.root == null)
            return;
        try {
            for (var _b = __values(this.observers), _c = _b.next(); !_c.done; _c = _b.next()) {
                var item = _c.value;
                item.observer.disconnect();
                this.applyProxyObserver(item);
            }
        }
        catch (e_3_1) { e_3 = { error: e_3_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_3) throw e_3.error; }
        }
    };
    StyleProxy.prototype.applyProxyObserver = function (proxyObserver) {
        var targets;
        if (proxyObserver.selector == null) { // observe all
            targets = [this.root].concat(Array.prototype.slice.call(this.root.querySelectorAll('*')));
        }
        else {
            targets = this.root.querySelectorAll(proxyObserver.selector);
        }
        for (var i = 0; i < targets.length; i++) {
            var target = targets[i];
            if (target instanceof HTMLElement) {
                proxyObserver.observer.observe(target, { attributes: true, attributeFilter: ['style'] });
            }
        }
    };
    return StyleProxy;
}());
exports.StyleProxy = StyleProxy;
